module.exports = __webpack_public_path__ + "img/weight_three.e3618d7b.png";